import React from 'react';

import Jimp from 'jimp';
import Potrace from 'potrace';

import { Button, Upload, message } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { parse } from 'svgson';

const { Dragger } = Upload;

const UploadSvg = (props) => {
    const draggerProps = {
        name: 'file',
        multiple: false,
        listType: "picture",
        maxCount: 1,
        showUploadList: true,

        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
    };



    const handleUpload = (event) => {
        console.log(event)

        if (event.type != "image/jpeg" && event.type != "image/png" && event.type != "image/gif") {
            message.error(`${event.type} file type is not accepted`);
            return;
            
        }

        Jimp.read(URL.createObjectURL(event))
            .then(image => {
                console.log(image);
            });


        const trace = new Potrace.Potrace();

        // You can also pass configuration object to the constructor
        trace.setParameters({
            blackOnWhite: false
            //background: '#880000'
        });

        trace.loadImage(URL.createObjectURL(event),
            function (err) {
                if (err) throw err;
                console.log(trace.getSVG());
                parse(`${trace.getSVG()}`).then((json) => {
                    var newSvg = json;
                    newSvg.attributes.width = "100%";

                    // split up the paths

                    var newChildren = [];
                    for (let index = 0; index < json.children.length; index++) {

                        // if (props.svg.children[index].attributes['fill'] === "white") {
                        const newString = json.children[index].attributes['d'].replace(/M/g, "|M")

                        const newArray = newString.split("|");


                        for (var i = 0; i < newArray.length; i++) {
                            var item = (' ' + newArray[i]).slice(1);
                            if (item !== "") {
                                //console.log(item, i);
                                const child = Object.assign({}, json.children[index]);
                                // console.log("item", item);
                                const attributes = Object.assign({}, child.attributes);
                                attributes.d = item;
                                child.attributes = attributes;
                                // console.log("attributes after", child.attributes.d);
                                // console.log("child after", child);

                                newChildren.push(child);
                            }
                        }
                    }
                    console.log("newChildren: ", newChildren);
                    newSvg.children = newChildren;


                    console.log(newSvg);
                    props.setSvg(newSvg);
                });
            });

        // const reader = new FileReader()
        // reader.onload = event => {
        //     console.log(event.target.result) // desired file content

        //     // set width property to be 100% so it scales according to window
        //     parse(`${event.target.result}`).then((json) => {
        //         var newSvg = json;
        //         newSvg.attributes.width = "100%";
        //         console.log(newSvg);
        //         props.setSvg(newSvg);
        //     });

        // }


        // reader.readAsText(event) // you could also read images and other binaries


    }

    //   const uploadProps = {
    //     beforeUpload: file => {
    //         console.log(file.type);
    //       const isSVG = file.type === 'image/svg+xml';
    //       if (!isSVG) {
    //         message.error(`${file.name} is not a svg file`);
    //       }
    //       return isSVG|| Upload.LIST_IGNORE;
    //     }
    //   };

    return (
        // <Upload
        //     //{...uploadProps}
        //     action={handleUpload}
        //     listType="picture"
        //     maxCount={1}
        //     showUploadList={false}

        // >
        //     <Button icon={<UploadOutlined />}>Upload Coloring Page</Button>
        // </Upload>

        <Dragger {...draggerProps}
            action={handleUpload}
            
        >
            <p className="ant-upload-drag-icon">
                <InboxOutlined />
            </p>
            <p className="ant-upload-text">Click or drag file to this area to upload</p>
            <p className="ant-upload-hint">
                Upload any PNG or JPEG image you want to convert
            </p>
        </Dragger>
    );
};

export default UploadSvg;